// External
import KeyOffIcon from '@mui/icons-material/KeyOff';

export const NotAuthorizedError = () => (
  <div className="mt-10 flex flex-col items-center justify-center">
    <KeyOffIcon style={{ fontSize: 128, color: '#9E9E9E' }} />
    <p>Access denied. You are not authorized to view this page.</p>
  </div>
);
